module.exports = __webpack_public_path__ + "static/media/donut-truck.06e90da7.svg";